import { Button } from 'components/Button/Button';
import { NavLink } from 'react-router';
import styled from 'styled-components';

export const NavStyled = styled.nav<{ $sticky: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 20px 80px;
  transition: all 0.2s ease;
  z-index: 100;
  background: ${({ theme }) => theme.black};

  img {
    width: 60px;
  }

  ${({ $sticky, theme }) =>
    $sticky &&
    `
    padding: 15px 50px;
    background: ${theme.black}cc;

     img {
    width: 40px;
  }
    `}

  @media (max-width: 1000px) {
    padding: 15px 30px;
    img {
      width: 40px;
    }

    ${({ $sticky }) =>
      $sticky &&
      `
       padding: 15px 30px;

  
    `}
  }
`;

export const NavLinkStyled = styled(NavLink)`
  font-size: 20px;
  color: ${({ theme }) => theme.primary};
  text-decoration: none;
  :hover {
    color: ${({ theme }) => theme.primary};
  }
`;

export const NavLinkAStyled = styled.a`
  font-size: 20px;
  color: ${({ theme }) => theme.primary};
  text-decoration: none;
  :hover {
    color: ${({ theme }) => theme.primary};
  }
`;

export const SignUpButton = styled(Button)`
  height: 40px;
  font-weight: 400;
  width: 110px;
`;

export const SignInButton = styled(SignUpButton)`
  font-weight: 400;
  background: none;
  border: 2px solid ${({ theme }) => theme.primary};
`;

export const LogOutButton = styled.div`
  cursor: pointer;
  font-size: 18px;
  color: #fff;
`;

export const NavMenuMobile = styled.div<{ $isOpen: boolean }>`
  background: ${({ theme }) => theme.black};
  padding: 100px 20px;
  position: absolute;
  top: 70px;
  right: -110%;
  width: 100%;
  bottom: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
  height: calc(100vh - 70px);
  transition: all 0.3s ease;

  @media (max-width: 1000px) {
    ${({ $isOpen }) =>
      $isOpen &&
      `
    right: 0;
  `}
  }
`;
